import Types from './history-types.store'
import { IHistoryState } from './history-states.store';
import { MutationTree } from 'vuex';
const mutations: MutationTree<IHistoryState> = <MutationTree<IHistoryState>>{
  [Types.Set.LIST_OF_HISTORY]: (state: IHistoryState, payload: { result: any, key: string }) => {
    state.source[payload.key] = payload.result;
  }
  , [Types.Set.SET_CHILDREN]: (state: IHistoryState, payload: { result: any, key: string, index: number }) => {
    try {
      state.source[payload.key].listOfItems[payload.index].children = payload.result
    }
    catch (ex) { console.log(ex) }
  }
}

export default mutations